var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.googleAuth && _vm.googleAuth.is_v1_google)?_c('GoogleV1',_vm._b({on:{"change":function($event){return _vm.$emit('change', $event)}}},'GoogleV1',_vm.$props,false)):_c('GoogleV2',_vm._b({on:{"change":function($event){return _vm.$emit('change', $event)}}},'GoogleV2',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }